'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var deriveTextShades = function(neutral, white) {
    return _extends({}, neutral && {
        primary: {
            day: neutral[900],
            night: neutral[40]
        },
        mediumHigh: {
            day: neutral[500],
            night: neutral[50]
        },
        medium: {
            day: neutral[300],
            night: neutral[60]
        },
        secondary: {
            day: neutral[100],
            night: neutral[80]
        },
        tertiary: {
            day: neutral[80],
            night: neutral[100]
        },
        quaternary: {
            day: neutral[60],
            night: neutral[300]
        }
    }, neutral && white && {
        inverted: {
            day: white[100],
            night: neutral[900]
        },
        onColor: {
            day: white[100],
            night: neutral[40]
        }
    });
};

export { deriveTextShades };
